import { onRequest } from '../..';
import { ActionsType, PropertyType } from '../../../common';
import { getCasinoGamePartners } from '../../../api/endpoints/getCasinoGamePartners';

const gamePartnersInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { gamePartners, pagesTotal } = await getCasinoGamePartners({ token, page, query: '', perPage });
	return { gamePartners: gamePartners, bulkRows: [], pagesTotal, currentPage: page, gamesLoading: false };
};

const gamePartnerInit = async (state: PropertyType, payload: PropertyType) => {
	const { token, id } = payload;
	const { gamePartner } = await getCasinoGamePartners({ token, id });

	const gamePartnersData = {
		game_name: gamePartner.name,
		game_id: gamePartner.id,
	};

	return { gamesLoading: false, gamePartnerForm: gamePartnersData };
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	return filterData(token, page, state.filters, perPage);
};

// const formReset = () => {
// 	return {
// 		gameFormPartner: {
// 			game_name: '',
// 		},
// 	};
// };

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters, state.perPage);
};

const filterData = async (token: string, page: string, filters: PropertyType[], perPage: string) => {
	const query = filters.length ? getFiltersUrl(filters) : '';
	const data = await getCasinoGamePartners({ token, page, query, perPage });

	return {
		...data,
		filters,
		filtering: filters.length > 1,
		bulkRows: [],
		currentPage: page,
		gamesLoading: false,
	};
};

const getFiltersUrl = (filters: PropertyType[]) => {
	const urlFragments = filters.map((f) => {
		const name = f.name === 'checksumStatuses' ? 'checksum_last_statuses' : f.name;
		return `${name}=${f.value}`;
	});

	return `?${urlFragments.join('&')}`;
};

export const actions: ActionsType = {
	GAME_PARTNERS_INIT: (state, payload) => onRequest(() => gamePartnersInit(payload), true),
	GAME_PARTNER_INIT: (state, payload) => gamePartnerInit(state, payload),
	LOADING: (state, payload) => ({ gamesLoading: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	SAVING: (state, payload) => ({ savingData: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', usersLoading: false }),
};
